import { useRouter } from 'next/router';
import { useStyles } from './useStyles';
import { Typography } from '@mui/material';
import Button from '@components/Button';

const JoinForMeal = () => {
  const classes = useStyles();
  const router = useRouter();
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Typography variant="h1" color="cinnamon.main">
          Join us for a meal!
        </Typography>
      </div>
      <Button
        variant="contained"
        color="turmeric"
        textColor="garamMasala.main"
        borderRadius="24"
        onClick={() => router.push('/order/step-1')}
        className={classes.btn}
      >
        Start a Subscription
      </Button>
    </div>
  );
};

export default JoinForMeal;
